module.exports = __webpack_public_path__ + "img/pixing_xc14.6c349ab5.jpg";